import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteCompanyAppendix = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`company-appendices/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-appendices'] });
    },
  });

  const deleteCompanyAppendix = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteCompanyAppendix,
    error,
    isLoading,
    reset,
  };
};
